import { useCallback, useEffect, useState } from "react";
import { Modal, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import SelectSearchable from "../../SelectSeachble/SelectSearchble";
import { ListarClinicas } from "../../../Service/Serive.clinica";
import { ListarTipoDocumento } from "../../../Service/Service.tipoDocumento";
import { ListarRolesAdmin } from "../../../Service/Service.roles";
import { SubirMedia } from "../../../Service/ServiceExternal";
import { CambiarRolUsuario, Crearuser } from "../../../Service/Service.users";
import usePermissions from "../../../hook/usePermissions";
import {
    buildAdministrativeUserPayload,
    buildAssignableRoleOptions,
    buildRoleChangePayload,
    validateAdministrativeUser,
    validateRoleChange,
    humanizeRoleName,
} from "./userCrudRbac";
import { getPasswordRuleItems } from "../../../utils/passwordPolicy";

const initialUserState = {
    id: 0,
    full_name: "",
    user_name: "",
    user_email: "",
    user_level: "",
    pwd: "",
    banned: 0,
    foto_user: "",
    idclinica: 0,
    idcompany: 0,
    sidebar: false,
    tips: false,
    tour: false,
    users_clinicas: [],
    documento: "",
    tipo_documento: null,
    nivel_user_id: null,
    idrol: null
};

export default function UserCrud({ data }) {

    const { show, handleClose, userData, onRoleChanged } = data;

    const [loading, setLoading] = useState(false);
    const [listarClinicas, setListarClinicas] = useState([])
    const [selectedClinicaOption, setSelectedClinicaOption] = useState(null);

    const [tipoDocumentos, setTipoDocumentos] = useState([]);
    const [selectedTipoDocOption, setSelectedTipoDocOption] = useState(null);

    // RP-06A: catalogo de roles RBAC asignables -- SOLO se usa en el flujo
    // de CREACION (ver seccion 7: la eleccion legacy de "Perfil" -- nivel_user --
    // se retira del flujo CREATE, pero se conserva sin cambios en EDICION).
    const [roles, setRoles] = useState([]);
    const [rolesLoading, setRolesLoading] = useState(false);
    const [rolesError, setRolesError] = useState("");
    const [selectedRoleOption, setSelectedRoleOption] = useState(null);
    const [showRoleModal, setShowRoleModal] = useState(false);
    const [selectedNewRoleOption, setSelectedNewRoleOption] = useState(null);
    const [selectedRoleClinics, setSelectedRoleClinics] = useState([]);
    const [selectedRoleCompanies, setSelectedRoleCompanies] = useState([]);
    const [roleChangeError, setRoleChangeError] = useState("");
    const { hasPermission } = usePermissions();

    const CargarAvatar = async (file) => {
        const url = await SubirMedia(file, null, null, 0, 'avatar')
        setUser({
            ...user,
            foto_user: url
        })
    }

    const [user, setUser] = useState(initialUserState)

    // RP-06A seccion 5/14: CREATE exige rol RBAC; EDIT mantiene la
    // compatibilidad legacy actual (nunca exige idrol -- ActualizarUsuario/
    // PUT no lo requiere ni lo usa).
    const esCreacion = !user.id;

    const sendFormHandleCliente = async () => {

        try {
            const validationMessage = validateAdministrativeUser({
                user,
                isCreate: esCreacion,
                selectedRoleOption,
                selectedClinicOptions: selectedClinicaOption,
            });
            if (validationMessage) {
                Swal.fire({
                    icon: "warning",
                    title: "Validación",
                    text: validationMessage,
                });
                return;
            }

            setLoading(true);

            const payload = buildAdministrativeUserPayload({
                user,
                isCreate: esCreacion,
                selectedRoleOption,
                selectedClinicOptions: selectedClinicaOption,
            });

              console.log(payload)

            const response = await Crearuser(payload)
            if (!response.success) {
                throw new Error(response.message || "Error al crear usuario");
            }

            Swal.fire({
                icon: "success",
                title: "Éxito",
                text: response.message,
                timer: 1500,
                showConfirmButton: false,
            });

            handleClose();

        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.message || "Hubo un error al crear cliente",
            });

        } finally {
            setLoading(false);
        }
    }

    const handleChangeClinica = selectedClinicaOption => {
        console.log(selectedClinicaOption)
        setSelectedClinicaOption(selectedClinicaOption);
        if (selectedClinicaOption && selectedClinicaOption.length > 0) {
            setUser({
                ...user,
                users_clinicas: selectedClinicaOption.map(option => option.value),
                idclinica: selectedClinicaOption[0].value,
                idcompany: selectedClinicaOption[0].idcompany
            });
        } else {
            setUser({
                ...user,
                users_clinicas: [],
                idclinica: 0,
                idcompany: 0
            });
        }
    };

    const handleChangeTipoDoc = selectedTipoDocOption => {
        setSelectedTipoDocOption(selectedTipoDocOption);
        setUser({
            ...user,
            tipo_documento: selectedTipoDocOption.value
        })
    };

    // RP-06A: value = idrol devuelto por backend (nunca inventado en
    // frontend). El scope_type viaja junto a la opcion para poder derivar
    // `company_ids` al enviar (seccion 10) sin una segunda consulta.
    const handleChangeRole = selectedRoleOption => {
        setSelectedRoleOption(selectedRoleOption);
        setUser({
            ...user,
            idrol: selectedRoleOption ? selectedRoleOption.value : null
        })
    };

    const companyOptions = [
        ...new Map(listarClinicas.map((clinica) => [
            clinica.idcompany,
            { value: clinica.idcompany, label: `Company ${clinica.idcompany}` }
        ])).values()
    ];

    const currentRoleName =
        user.rbac_role?.rol?.nombre ||
        user.role?.nombre ||
        user.role?.name ||
        user.rol?.nombre ||
        "Sin rol RBAC";
    const passwordRuleItems = getPasswordRuleItems(user.pwd || "", {
        email: user.user_email,
        userName: user.user_name,
        fullName: user.full_name,
    });

    const openRoleModal = () => {
        setSelectedNewRoleOption(null);
        setSelectedRoleClinics(selectedClinicaOption || []);
        setSelectedRoleCompanies([]);
        setRoleChangeError("");
        setShowRoleModal(true);
    };

    const confirmRoleChange = async () => {
        if (loading) return;
        setRoleChangeError("");
        const validationMessage = validateRoleChange({
            selectedRoleOption: selectedNewRoleOption,
            selectedClinicOptions: selectedRoleClinics,
            selectedCompanyOptions: selectedRoleCompanies,
        });
        if (validationMessage) {
            setRoleChangeError(validationMessage);
            return;
        }

        setLoading(true);
        try {
            const response = await CambiarRolUsuario(user.id, buildRoleChangePayload({
                selectedRoleOption: selectedNewRoleOption,
                selectedClinicOptions: selectedRoleClinics,
                selectedCompanyOptions: selectedRoleCompanies,
            }));
            if (!response?.success) throw new Error(response?.message || "No se pudo cambiar el rol");
            const updatedUser = response.data?.[0] || {
                ...user,
                rbac_role: { rol: { nombre: selectedNewRoleOption.nombre || selectedNewRoleOption.label } },
            };
            setUser({
                ...updatedUser,
                users_clinicas: (updatedUser.users_clinicas || []).map((u) => u.idclinica),
                pwd: null,
            });
            Swal.fire({ icon: "success", title: "Éxito", text: response.message, timer: 1500, showConfirmButton: false });
            setShowRoleModal(false);
            if (onRoleChanged) onRoleChanged(updatedUser);
        } catch (error) {
            // RBAC-CUSTOM-ROLES-03B seccion Y: el backend responde 409 con un
            // mensaje funcional real (p.ej. el bloqueo por usuario
            // multi-clinica en un rol personalizado) -- se muestra tal cual,
            // nunca el mensaje generico de axios.
            const backendMessage = error?.response?.data?.message;
            setRoleChangeError(backendMessage || error.message || "No se pudo cambiar el rol");
        } finally {
            setLoading(false);
        }
    };

    const fetchInitialData = useCallback(async () => {

        const dataClinicas = await ListarClinicas();
        const clinicaOptions = dataClinicas.map((cli) => ({ value: cli.idclinica, label: cli.nombre, idcompany: cli.idcompany }));
        setListarClinicas(clinicaOptions);

        const documentos = await ListarTipoDocumento();
        if (documentos.success) {
            setTipoDocumentos(documentos.data.map(d => ({ value: d.idtipodocumento, label: d.tipo })))
        }

        // RBAC-CUSTOM-ROLES-03C: fuente unica para asignacion UI = GET /roles.
        // El backend ya entrega roles Sistema visibles + custom dentro del
        // scope del actor; /roles/assignable queda como endpoint legacy no
        // usado para roles personalizados en este flujo.
        setRolesLoading(true);
        setRolesError("");
        setRoles([]);
        try {
            const dataRoles = await ListarRolesAdmin();
            if (!dataRoles.success) {
                throw new Error(dataRoles.message || "No se pudo cargar roles");
            }
            setRoles(buildAssignableRoleOptions(dataRoles.data || []));
        } catch (error) {
            const message = error?.response?.data?.message || error.message || "No se pudo cargar roles";
            setRoles([]);
            setRolesError(message);
        } finally {
            setRolesLoading(false);
        }

    }, []);

    const fetchInitialDataUser = useCallback(async (user) => {

        if (!user) return;

        const tipoDocSelected = tipoDocumentos.find(opt => opt.value === user.tipo_documento);
        setSelectedTipoDocOption(tipoDocSelected || null);

        const idsClinicas = user.users_clinicas.map(u => u.idclinica);

        const clinicasSeleccionadas = listarClinicas.filter(opt => idsClinicas.includes(opt.value));
        
        setSelectedClinicaOption(clinicasSeleccionadas);

        setUser({
            ...user,
            users_clinicas: idsClinicas,
            pwd: null // Así no se muestra nada en el input ni se envía una cadena vacía
        });
        
        /*setUser({
            ...user,
            users_clinicas: idsClinicas
        });*/


    }, [tipoDocumentos, listarClinicas]);


    useEffect(() => {
        if (show) {
            if (!userData) {
                setUser(initialUserState);
                setSelectedClinicaOption(null);
                setSelectedTipoDocOption(null);
                setSelectedRoleOption(null);
            }
            fetchInitialData();
        }
    }, [show, userData, fetchInitialData]);

    /*useEffect(() => {
        if (userData) {
            fetchInitialDataUser(userData);
        }
    }, [userData, fetchInitialDataUser]);*/
    useEffect(() => {
        if (show && userData) {
            fetchInitialDataUser(userData);
        }
    }, [show, userData, fetchInitialDataUser]);
    

    return (
        <Offcanvas keyboard={false}
            show={show}
            onHide={handleClose}
            placement="end"
            style={{ zIndex: 10000 }}
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>   </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="d-flex flex-column">

                <div className="h-auto">

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Clinicas *</label>
                                <SelectSearchable
                                    listCompany={listarClinicas}
                                    handleChange={handleChangeClinica}
                                    selectedOption={selectedClinicaOption}
                                    placeholder="Seleccione clinicas"
                                    isMulti={true}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 pt-4">
                            <div className="form-group">
                                <label>Tipo de Documento *</label>
                                <SelectSearchable
                                    listCompany={tipoDocumentos}
                                    handleChange={handleChangeTipoDoc}
                                    selectedOption={selectedTipoDocOption}
                                    placeholder="Seleccione"
                                    isMulti={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 pt-4">
                            <div className="form-group">
                                <label>No. Documento *</label>
                                <input type='text'
                                    className='form-control'
                                    value={user.documento}
                                    onChange={(e) => setUser({ ...user, documento: e.target.value })} />
                            </div>
                        </div>
                    </div>

                    {/* RP-06A seccion 7: la eleccion legacy de nivel_user_id
                        ("Perfil") se retira del flujo de CREACION -- la
                        autoridad del usuario nuevo viene de idrol (RBAC).
                        Se conserva SIN CAMBIOS en EDICION de usuarios
                        existentes (ActualizarUsuario sigue sin exigir/usar
                        idrol). */}
                    {esCreacion ? (
                        <div className="row">
                            <div className="col-md-12 pt-4">
                                <div className="form-group">
                                    <label>Rol / plantilla *</label>
                                    <SelectSearchable
                                        listCompany={roles}
                                        handleChange={handleChangeRole}
                                        selectedOption={selectedRoleOption}
                                        placeholder={rolesLoading ? "Cargando roles..." : "Seleccione un rol"}
                                        isMulti={false}
                                        isDisabled={rolesLoading || !!rolesError || roles.length === 0}
                                    />
                                    {rolesLoading && <div className="small text-muted mt-1">Cargando roles...</div>}
                                    {rolesError && <div className="small text-danger mt-1">{rolesError}</div>}
                                    {!rolesLoading && !rolesError && roles.length === 0 && (
                                        <div className="small text-muted mt-1">No hay roles disponibles.</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-md-12 pt-4">
                                <div className="form-group">
                                    <label>Rol actual</label>
                                    <div className="d-flex align-items-center gap-2">
                                        <input className="form-control" value={humanizeRoleName(currentRoleName)} readOnly />
                                        {hasPermission("users.assign_role") && (
                                            <button type="button" className="btn btn-outline-primary" onClick={openRoleModal}>
                                                Cambiar rol
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row">
                        <div className="col-md-12 pt-4">
                            <div className="form-group">
                                <label>Nombres *</label>
                                <input type='text'
                                    className='form-control'
                                    value={user.full_name}
                                    onChange={(e) => setUser({ ...user, full_name: e.target.value })} />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 pt-4">
                            <div className="form-group">
                                <label>Usuario *</label>
                                <input type='text'
                                    className='form-control'
                                    value={user.user_name}
                                    onChange={(e) => setUser({ ...user, user_name: e.target.value })} />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 pt-4">
                            <div className="form-group">
                                <label>Email *</label>
                                <input type='text'
                                    className='form-control'
                                    value={user.user_email}
                                    onChange={(e) => setUser({ ...user, user_email: e.target.value })} />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 pt-4">
                            <div className="form-group">
                                <label>Password {esCreacion ? "*" : ""}</label>
                                <input
                                    type='password'
                                    className='form-control'
                                    value={user.pwd || ""} // para evitar que sea null
                                    onChange={(e) => setUser({ ...user, pwd: e.target.value })}
                                />
                                <div className="small mt-2">
                                    {passwordRuleItems.map((rule) => (
                                        <span
                                            key={rule.key}
                                            className={`me-3 ${rule.passed ? "text-success" : "text-muted"}`}
                                        >
                                            {rule.passed ? "✓" : "○"} {rule.label}
                                        </span>
                                    ))}
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Avatar</label>

                                <div className="col-sm-12">

                                    <div className="input-group">
                                        <span className="input-group-btn">
                                            <span className="btn btn-default btn-file">
                                                Browse… <input type="file" id="imgInp" name="imgInp" accept="image/gif, image/jpeg, image/png" onChange={(e) => CargarAvatar(e.target.files[0])} />
                                            </span>
                                        </span>
                                    </div>
                                    <br />
                                    <input type="hidden" id="hlogo" name="hlogo" />
                                    <div align="left">
                                        {
                                            user.foto_user === '' ? <img src="https://www.thermaxglobal.com/wp-content/uploads/2020/05/image-not-found.jpg" id="img-upload" className="img-thumbnail" data-holder-rendered="true" style={{ maxWidth: '250px' }} alt="Avatar" /> :
                                                <img src={user.foto_user} id='img-upload' className="img-thumbnail" data-holder-rendered="true" style={{ maxWidth: '250px' }} alt="Avatar" />
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>

                <div className="p-3 w-100 text-center mt-4">
                    <button className="btn btn-primary w-100"
                        onClick={sendFormHandleCliente}
                        disabled={loading || (esCreacion && (rolesLoading || !!rolesError || roles.length === 0))}
                    >
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                {" "}Por favor espere...
                            </>
                        ) : "Crear"}
                    </button>
                </div>

            </Offcanvas.Body>
            <Modal show={showRoleModal} onHide={() => !loading && setShowRoleModal(false)} centered style={{ zIndex: 10001 }}>
                <Modal.Header closeButton>
                    <Modal.Title>Cambiar rol</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label>Nuevo rol</label>
                        <SelectSearchable
                            listCompany={roles}
                            handleChange={setSelectedNewRoleOption}
                            selectedOption={selectedNewRoleOption}
                            placeholder={rolesLoading ? "Cargando roles..." : "Seleccione un rol"}
                            isMulti={false}
                            isDisabled={rolesLoading || !!rolesError || roles.length === 0}
                        />
                        {rolesLoading && <div className="small text-muted mt-1">Cargando roles...</div>}
                        {rolesError && <div className="small text-danger mt-1">{rolesError}</div>}
                        {!rolesLoading && !rolesError && roles.length === 0 && (
                            <div className="small text-muted mt-1">No hay roles disponibles.</div>
                        )}
                    </div>
                    {selectedNewRoleOption?.scope_type === "CLINIC" && (
                        <div className="form-group pt-3">
                            <label>Clínicas</label>
                            <SelectSearchable
                                listCompany={listarClinicas}
                                handleChange={setSelectedRoleClinics}
                                selectedOption={selectedRoleClinics}
                                placeholder="Seleccione clínicas"
                                isMulti={true}
                            />
                        </div>
                    )}
                    {selectedNewRoleOption?.scope_type === "COMPANY" && (
                        <div className="form-group pt-3">
                            <label>Compañías</label>
                            <SelectSearchable
                                listCompany={companyOptions}
                                handleChange={setSelectedRoleCompanies}
                                selectedOption={selectedRoleCompanies}
                                placeholder="Seleccione compañías"
                                isMulti={true}
                            />
                        </div>
                    )}
                    {selectedNewRoleOption && (
                        <div className="alert alert-warning mt-3 mb-0">
                            <div><strong>Usuario:</strong> {user.user_email}</div>
                            <div><strong>Rol actual:</strong> {humanizeRoleName(currentRoleName)}</div>
                            <div><strong>Rol nuevo:</strong> {selectedNewRoleOption.nombre || selectedNewRoleOption.label}</div>
                            <div><strong>Extras:</strong> se conservan</div>
                        </div>
                    )}
                    {roleChangeError && <div className="alert alert-danger mt-3 mb-0">{roleChangeError}</div>}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-light" onClick={() => setShowRoleModal(false)} disabled={loading}>Cancelar</button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={confirmRoleChange}
                        disabled={loading || rolesLoading || !!rolesError || roles.length === 0 || !selectedNewRoleOption}
                    >
                        {loading ? "Confirmando..." : "Confirmar"}
                    </button>
                </Modal.Footer>
            </Modal>
        </Offcanvas>
    );
}
